import { processListingParams } from '@/api/helpers';
import { getExceptionFromAxiosError } from '@/client/helpers';
import {
  ListTagsRequest,
  ListTagsResponse,
  SaveTagRequest,
  Tag,
} from '@/client/tags';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

export const tagsService = (client: AxiosInstance) => {
  const TAGS_BASE_URL = '/course-tags';

  const getTags = async (
    params: ListTagsRequest,
  ): Promise<ListTagsResponse> => {
    try {
      const result = await client.get<
        ListTagsResponse,
        AxiosResponse<ListTagsResponse>
      >(TAGS_BASE_URL, {
        withCredentials: true,
        params: processListingParams(params),
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const getTag = async (tagId: string): Promise<Tag> => {
    try {
      const result = await client.get<Tag, AxiosResponse<Tag>>(
        `${TAGS_BASE_URL}/${tagId}`,
        {
          withCredentials: true,
        },
      );

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const createTag = async (request: SaveTagRequest): Promise<Tag> => {
    try {
      const result = await client.post<Tag, AxiosResponse<Tag>>(
        TAGS_BASE_URL,
        request,
        {
          withCredentials: true,
        },
      );

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  return {
    getTags,
    getTag,
    createTag,
  };
};
